import React, { useEffect, useState } from 'react';
import { cepci_item, cepci_item2 } from '../../json/cepciItem';
import './cepci.css';

const CEPCI = () => {
    const [urlImage, setUrlImage] = useState("");
    const [titleModal, setTitleModal] = useState("");

    const changesUrlImageAndTitle = (url, title) => {
        setUrlImage(url);
        setTitleModal(title)
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container'>
            <div className='row'>
                <h3 className='title'>Cómite de Ética y Prevención de Conflictos de Interes de la Oficialía Mayor</h3>
                <hr className='hr-gob' />
                <h6>
                </h6>
            </div>


            <div className='row'>
                {
                    cepci_item2.map((item, index) => (
                            <div key={index} class="col-md-3 col-sm-6 col-12" >
                                <div data-bs-toggle="modal" data-bs-target="#modalcedulas" onClick={() => { changesUrlImageAndTitle(item.url, item.id) }}>
                              
                                     <img src={"/assets/imgs/" + item.icono} className='card-img-top_cepci' alt=''/>
                                    <br></br>
                                   
                                </div>
                            </div>
                    ))
                }

                <div className="modal fade" id="modalcedulas" tabindex="-1" aria-labelledby="modalcedulasLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">

                                <h5 className="modal-title_cedula" id="modalcedulasLabel">{titleModal}</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <img className='imgmodal' src={urlImage} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
          
                {
                    cepci_item.map((item, index) => (
                        <div key={index} class="col-md-3 col-sm-6 col-12">
                            <div >
                                <a href={item.url} >
                               
                                    <img src={"/assets/imgs/" + item.icono} className='card-img-top_cepci' alt='' />
                                   
                                </a>
                              
                            </div>
                            <br></br>
                        </div>
                    ))
                }
            </div>
     </div>
    )
}

export default CEPCI